import { API_URL } from "../../constants";
import * as httpNetworking from "../../httpNetworking";

const URL = API_URL + "/user/info";
const VERSION = 0;

export default async function updateUserInfo(name: string): Promise<void> {
    const options: httpNetworking.PUTRequestConfig = {
        timeout: 50000
    };
    const params = {
        name
    };

    const response = (await httpNetworking.simplePUTRequest(URL, params, options, VERSION)).data;
    return response;
}
